import { EwebinarFragmentForSessions } from '$/shared/frontend/types';
import EDate from '$/shared/frontend/utils/EDate';
import { SessionCalculator } from '$/shared/frontend/utils/SessionCalculator';
import type { EwebinarSessions } from '$/shared/typesProxy';
import { ServerDateNow } from '$/utils/serverDate';
import React from 'react';

type calcEWebinarSessions = (
  ewebinar: EwebinarFragmentForSessions,
  clientTimeZone: string,
  skipFromNow?: boolean,
  justInTimeDate?: EDate,
  justInTimeName?: string,
  serverDateNow?: ServerDateNow
) => Promise<EwebinarSessions>;

export const useEwebinarSessionCalculator = (): calcEWebinarSessions => {
  const calcEWebinarSession = React.useCallback(
    async (
      ewebinar: EwebinarFragmentForSessions,
      clientTimeZone: string,
      skipFromNow?: boolean,
      justInTimeDate?: EDate,
      justInTimeName?: string,
      serverDateNow?: ServerDateNow
    ): Promise<EwebinarSessions> => {
      const service = new SessionCalculator(ewebinar, clientTimeZone, serverDateNow);
      return service.getEwebinarSessions(null, skipFromNow, justInTimeDate, justInTimeName);
    },
    []
  );
  return calcEWebinarSession;
};
